import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrafficLightComponent } from '@app/pcs/shared/components/traffic-light/traffic-light.component';
import { IconModule } from 'pcs-component-library';

@NgModule({
  declarations: [
    TrafficLightComponent
  ],
  imports: [
    CommonModule,
    IconModule
  ],
  exports: [
    TrafficLightComponent
  ]
})
export class TrafficLightModule { }
